/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from '~/core';
setup();

import '~/global/_body';
import '~/global/_header';
import '~/global/_footer';

import '~/components/_accordion';
import '~/components/_composition-background';
import '~/components/_datePicker';
import '~/components/_detail';
import '~/components/_drawer';
import '~/components/_forms';
import '~/components/_gsap';
import '~/components/_map';
import '~/components/_modal';
import '~/components/_search';
import '~/components/_swiper';
import '~/components/_tabs';
